<template>
  <div>
    <client-only>
      <first-step v-if="step === 'first'" />
      <second-step v-if="step === 'second'" />
    </client-only>

    <b-modal title="Ошибка" centered :visible="errorText" @hidden="closeErrorMessage">
      <p class="my-4">
        {{ errorText }}
      </p>
    </b-modal>
  </div>
</template>

<script>
import { get, call } from 'vuex-pathify'
import FirstStep from '~/components/signup/FirstStep'
import SecondStep from '~/components/signup/SecondStep'
export default {
  components: { SecondStep, FirstStep },
  computed: {
    errorText: get('signup/operationError'),
    step: get('signup/step')
  },
  mounted () {
    this.ncalayerConnect()
  },
  beforeDestroy () {
    this.ncalayerDisconnect()
  },
  methods: {
    closeErrorMessage: call('signup/clearOperationError'),
    ncalayerConnect: call('ncalayer/connect'),
    ncalayerDisconnect: call('ncalayer/disconnect')
  },
  head: {
    title: 'Регистрация'
  }
}
</script>

<style scoped>

</style>
